var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data.properties.filed_content != 'Hide')?_c('div',{staticClass:"paragraphScroll",style:(_vm.getStyle)},[_vm._v(" "+_vm._s(_vm.data.content)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }